import { useMemo, useReducer } from 'react'

import * as Sentry from '@sentry/react'

import { isSentryLoggingEnabled } from 'shared/utils/sentry'

const logger = (reducer, type = null) => {
  const reducerWithLogger = (state, action, editor) => {
    const next = reducer(state, action, editor)
    const actionTypeTitle = 'Action Type'
    const groupTitle = type ? `${actionTypeTitle} (${type})` : actionTypeTitle

    console.groupCollapsed(
      `%c${groupTitle}: %c${action.type}`,
      'color: #527CEB; font-weight: 400;',
      'color: #527CEB; font-weight: 700;'
    )

    console.log('%cPrevious State:', 'color: #9E9E9E; font-weight: 700;', {
      ...state,
    })

    console.log('%cAction:', 'color: #1292EE; font-weight: 700;', action)
    console.log('%cNext State:', 'color: #39AC6E; font-weight: 700;', next)
    console.groupEnd()

    return next
  }

  return reducerWithLogger
}

const sentryLogger = (reducer, type = null) => {
  return (state, action, editor) => {
    const next = reducer(state, action, editor)

    Sentry.addBreadcrumb({
      category: type,
      message: action.type,
      level: 'info',
      data: {
        action,
        state,
        next,
      },
    })

    return next
  }
}

export function addLoggerToReducer(reducer, debug, type = null) {
  if (isSentryLoggingEnabled()) {
    return sentryLogger(reducer, type)
  }

  if (debug) {
    return logger(reducer, type)
  }

  return reducer
}

export function useReducerWithLogger(
  reducer,
  initialState,
  debug = true,
  type = null
) {
  const newReducer = useMemo(() => {
    return addLoggerToReducer(reducer, debug, type)
  }, [type, reducer, debug])

  return useReducer(newReducer, initialState)
}
